import './new-flavors-popup.scss'
import { FC, useState } from "react"
import { Button } from "primereact/button"
import { InputText } from "primereact/inputtext"
import { addICProductsByShop, updateICProductsByShop } from '../../productSlices'
import { useDispatch, useSelector } from 'react-redux'

interface NewFlavorsPopupProps {
    fullCommentary:string,
    isVisible:boolean,
    setVisible:Function,
    productToEdit?: any,
    setProductToEdit?: Function
}

const NewFlavorsPopup : FC<NewFlavorsPopupProps>= ({fullCommentary, isVisible,setVisible, productToEdit, setProductToEdit}) => {
    const dispatch: Function = useDispatch();
    const [flavors, setFlavors] = useState(productToEdit ? [productToEdit.name] : [''])
    const selectedShop = useSelector((state: any) => state.user.selectedShop);
    const addFlavorField = () => {
      if(flavors[flavors.length - 1] === '') return
      setFlavors([...flavors, ''])
    }
    const closePopup = () => {
      setVisible(false)
      setProductToEdit?.(null)
    }
    const sendFlavors = () => {
      if(productToEdit){
        if(flavors[0] !== ''){
          dispatch(updateICProductsByShop(selectedShop, productToEdit.id, {
            id: productToEdit.id,
            name: flavors[0],
            three_liter: productToEdit.three_liter,
            five_liter: productToEdit.five_liter,
            seven_liter: productToEdit.seven_liter
          }))
        }
      }else{
        flavors.forEach(flavor => {
          dispatch(addICProductsByShop(selectedShop, {name:flavor}))
        });
      }
      closePopup()
    }
    return (
      <>
      <div className="mask"></div>
      <div className="popup">
        <div className={`new-flavors-popup ${isVisible ? 'visible' : ''}`}>
          <div className="new-flavors-popup__header">
            <div className="new-flavors-popup__header__titles">
              <div className="new-flavors-popup__header__titles__title">{productToEdit ? 'Edit flavor 🍦' : 'New flavors 🍦'}</div>
              <div className="new-flavors-popup__header__titles__subtitle">{productToEdit ? 'Rename this flavor' : 'Add new flavors to your stock'}</div>
            </div>
            <Button onClick={() => closePopup()} icon="pi pi-times" iconPos='right' className="new-flavors-popup__header__close-button" />
          </div>
          <div className="new-flavors-popup__content">
            <div className="new-flavors-popup__content__title">{productToEdit ? 'Flavor name' : 'Enter a new flavor'}</div>
            {
              flavors.map((flavor, index) => (
                <div className="new-flavors-popup__content__input" key={index}>
                  <InputText value={flavor} onChange={(e) => {
                    const newFlavors = [...flavors]
                    newFlavors[index] = e.target.value
                    setFlavors(newFlavors)
                  }} />
                </div>
              ))
            }
            {!productToEdit && <div className="new-flavors-popup__content__clickable-text" onClick={()=>addFlavorField()}> + Add another flavor</div>}
          </div>
          <div className="new-flavors-popup__footer">
            <Button onClick={() => closePopup()} iconPos='right' label={'Cancel'} className="new-flavors-popup__footer__cancel-button" />
            <Button onClick={() => sendFlavors()} iconPos='right' label={'Confirm'} className="new-flavors-popup__footer__confirm-button" />
          </div>
        </div>
      </div>
      </>
    )
}

export default NewFlavorsPopup